import React from "react";
import { Stack } from "@mui/material";
import ProfileLayout from "../global/ProfileLayout";
import { ScholarPresets } from "./components/ScholarPresets";
import { ScholarStatistics } from "./components/ScholarStatistics";
import { BorrowedInventory } from "./components/BorrowedInventory";
import styled from "@emotion/styled";

const ContentWrapper = styled(Stack)({
  direction: "column",
  width: "100%",
  marginTop: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const ScholarDetailsProfileView = ({
  theme,
  colors,
  scholars,
  scholarId,
  scholar,
  nfts,
  games,
  NftBoxProps,
}) => {
  return (
    <ProfileLayout
      address={scholar?.scholarAddress}
      name={scholar?.scholarName}
      coverImage={scholar?.coverPic}
      profileImage={scholar?.profilePic}
      scholarId={scholarId}
    >
      <ContentWrapper>
        <ScholarPresets colors={colors} theme={theme} />
        <ScholarStatistics colors={colors} nfts={nfts} games={games} />
        <BorrowedInventory
          colors={colors}
          theme={theme}
          games={games}
          NftBoxProps={NftBoxProps}
        />
      </ContentWrapper>
    </ProfileLayout>
  );
};

export default ScholarDetailsProfileView;
